import { render, staticRenderFns } from "./StockInput.vue?vue&type=template&id=5b163b72&"
import script from "./StockInput.vue?vue&type=script&lang=js&"
export * from "./StockInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports